import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconFiletypeBlank16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.829 8.469l-2.015-.574a.816.816 0 11.529-1.542l1.99.803-.13-2.294A.816.816 0 018.016 4h.039c.468 0 .84.394.814.862L8.738 7.22l1.914-.78c.44-.18.94.054 1.085.506l.003.01a.816.816 0 01-.557 1.035l-2.066.577 1.364 1.737a.816.816 0 01-.167 1.168l-.029.02a.816.816 0 01-1.168-.233l-1.18-1.904-1.17 1.841a.816.816 0 01-1.148.237l-.014-.01a.816.816 0 01-.18-1.18L6.83 8.47z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconFiletypeBlank16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;